export const RELOAD_KEY = "spanda_error_reload_count";
export const MAX_RELOADS = 2;
export const EXPIRY_MS = 10 * 60 * 1000; // 10 min

export function shouldAutoReload(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = window.sessionStorage.getItem(RELOAD_KEY);
    if (!raw) return true;
    const data = JSON.parse(raw) as { c: number; ts: number };
    if (Date.now() - data.ts > EXPIRY_MS) {
      window.sessionStorage.removeItem(RELOAD_KEY);
      return true;
    }
    return data.c < MAX_RELOADS;
  } catch {
    return true; // if storage blocked, allow one reload attempt
  }
}

export function bumpReloadCount(): void {
  if (typeof window === "undefined") return;
  try {
    const raw = window.sessionStorage.getItem(RELOAD_KEY);
    const cur = raw ? (JSON.parse(raw) as { c: number; ts: number }) : { c: 0, ts: Date.now() };
    const expired = Date.now() - cur.ts > EXPIRY_MS;
    const next = expired ? { c: 1, ts: Date.now() } : { c: cur.c + 1, ts: cur.ts };
    window.sessionStorage.setItem(RELOAD_KEY, JSON.stringify(next));
  } catch {}
}

export function clearReloadCount(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(RELOAD_KEY);
  } catch {}
}
